import React from 'react';
import { LIBERTY_IMAGES } from '../../assets/asset';
import { QUOTE_TOKENS_BY_ID, TOP_PAIR_TOKEN_IDS } from '../../constants/exchangeQuoteTokens';

function TopPairPicker({ selectedId, onSelect }) {
  return (
    <div className="flex flex-wrap gap-2">
      {TOP_PAIR_TOKEN_IDS.map((id) => {
        const meta = QUOTE_TOKENS_BY_ID[id];
        const active = selectedId === id;
        const gradientMain = active
          ? 'opacity-100 transition-opacity duration-2000'
          : 'opacity-0 transition-opacity duration-2000 group-hover:opacity-100';
        const gradientBlur = active
          ? 'opacity-30 transition-opacity duration-2000'
          : 'opacity-0 transition-opacity duration-2000 group-hover:opacity-30';

        return (
          <button
            key={id}
            type="button"
            className="relative flex items-center gap-1.5 px-1.5 py-1.5 rounded-full transition-all duration-2000 bg-[var(--exchange-secondary-mobile)] md:bg-[var(--exchange-secondary-desktop)] hover:bg-[#333333] cursor-pointer group"
            style={{
              '--gradient-end': '#393941',
              '--gradient-start': '#393941',
            }}
            onClick={() => onSelect(id)}
          >
            <div
              className={`absolute inset-0 rounded-full bg-gradient-to-r from-[var(--gradient-start)] to-[var(--gradient-end)] ${gradientMain}`}
            />
            <div
              className={`absolute inset-0 rounded-full bg-gradient-to-r from-[var(--gradient-start)] to-[var(--gradient-end)] blur-[8px] -z-10 ${gradientBlur}`}
            />
            {id === 'usdc' ? (
              <div className="relative z-10 flex items-center gap-1.5 transition-transform duration-2000 group-hover:scale-95">
                <div className="relative">
                  <img
                    alt="USDC"
                    className="rounded-full bg-[#41424B]"
                    decoding="async"
                    height="24"
                    src={LIBERTY_IMAGES.USDC}
                    width="24"
                  />
                </div>
                <div className="flex items-center justify-center w-[18px]">
                  <img
                    alt="Swap"
                    decoding="async"
                    height="16"
                    src={LIBERTY_IMAGES.IC_ARROW_SWAP}
                    width="16"
                  />
                </div>
                <div className="relative">
                  <img
                    alt="USDC"
                    className="rounded-full bg-[#41424B]"
                    decoding="async"
                    height="24"
                    src={LIBERTY_IMAGES.USDC}
                    width="24"
                  />
                  <div className="absolute bottom-[-2px] -right-[2px] w-3 h-3 bg-[var(--exchange-secondary-mobile)] md:bg-[var(--exchange-secondary-desktop)] rounded-full flex items-center justify-center">
                    <img
                      alt="PulseChain"
                      className="rounded-full"
                      decoding="async"
                      height="10"
                      src={LIBERTY_IMAGES.PULSECHAIN}
                      width="10"
                    />
                  </div>
                </div>
              </div>
            ) : (
              <div className="relative z-10 transition-transform duration-2000 group-hover:scale-95">
                <div className="relative">
                  <img
                    alt={meta.label}
                    className="rounded-full bg-[#41424B]"
                    decoding="async"
                    height="24"
                    src={meta.tokenSrc}
                    width="24"
                  />
                  <div className="absolute bottom-[-2px] -right-[2px] w-3 h-3 bg-[var(--exchange-secondary-mobile)] md:bg-[var(--exchange-secondary-desktop)] rounded-full flex items-center justify-center">
                    <img
                      alt={meta.chainName}
                      className="rounded-full"
                      decoding="async"
                      height="10"
                      src={meta.chainSrc}
                      width="10"
                    />
                  </div>
                </div>
              </div>
            )}
          </button>
        );
      })}
    </div>
  );
}

export default TopPairPicker;
